import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestStatsCustomBypassGet = {
    path: "/stats/customBypass",
    method: RouteHttpVerb.GET
};
